export default __webpack_public_path__ + "static/media/tether.5a485e2f.svg";